import React, { useEffect, useMemo, useState } from 'react'

import { v4 as uniqid } from 'uuid'

import getFormStatus from '@/Form/Functions/getFormStatus'

import HomeProductSlideCard from '@/Home/HomeProductSlideCard'
import PlaceSlideCard       from '@/Home/PlaceSlideCard'

import Slider from '@/Slider'

import ajaxRequest from '@function/ajax/ajaxRequest'

import bemit from '@function/bemit'

export default function HomeHighlightSlider ({ role, ...props })
{
	const [status, setStatus] = useState({ });
	const [mixed_data, setMixedData] = useState([]);
	const [window_size, setWindowSize] = useState(String(window.innerWidth));

	useEffect(function ()
	{
		(async function ()
		{
			try
			{
				var { products, places } = await ajaxRequest(
				'/front/fetch-highlight-slider',
				{
					data: { limit: getProductsLimit() }
				});
			}
			catch (update)
			{
				setStatus(update);
			}

			const data = (
				(products || []).map(doc => ({ model: doc, type: 'product' }))
			)
			.concat(
				(places || []).map(doc => ({ model: doc, type: 'place' }))
			);

			setMixedData(data);
		})();
	},
	[window_size]);

	useEffect(function ()
	{
		window.addEventListener('resize', handleResize);

		return () => window.removeEventListener('resize', handleResize);

		function handleResize () { setWindowSize(String(window.innerWidth)); }
	},
	[]);

	const elements = useMemo(function ()
	{
		const cards = mixed_data.map(function (data)
		{
			return data.type === 'product'
			? <HomeProductSlideCard product={ data.model } key={ data.model.id } />
			: <PlaceSlideCard place={ data.model } key={ data.model.id } />;
		});

		const cards_per_slide = getProductsPerSlide();

		return Array.from({ length: getMaxSlidesCount() })
		.map(function (_v, i)
		{
			const range_start = i*cards_per_slide;

		// ex : slider [ [1 2 3] [4 5 6] [7 8 9] ] <- il y a trois ranges
			const slide_range = [range_start, range_start+cards_per_slide];

			const slide =
			{
				id: uniqid()
			};

		// il n'y a plus rien à afficher à partir de cette range
			if (!mixed_data[i]) return null;

		// ex : [4, 5, 6] <- index des cards, vide si plus grand que le nombre
		// de cards (il peut y avoir 4 mais pas 5 ni 6)
			slide.content = Array.from({ length: cards_per_slide })
			.map(function (_v, k)
			{
				const card = cards[slide_range[0] + k];

				if (!card) // placeholder, évite le flex-grow ou utiliser grid
				{
					return (
						<div className={ bemit('c-model-preview-item',
							['blog', 'slider', 'ad']) }
							key={ uniqid() }
						/>
					);
				}

				return (
					<div key={ uniqid() } className="u-flex u-full-width">
						{ card }
					</div>
				);
			});

			return slide;
		})
		.filter(item => item !== null);
	},
	[mixed_data]);

	if (role === 'EC' && !props.force) return null;

	if (!elements.length) return null;

	return (
		<div className="dashboard-list u-margin-top-0">

			<div className="c-title c-title--v2 u-margin-top-20">
				<h2 className="c-title__txt">
					À ne pas rater
				</h2>
			</div>

			<Slider key={ window_size }
				type="custom" elements={ elements }
				bemit={ ['highlighted', 'multiple'] }
				hide-progress auto
			/>

			{ getFormStatus(status) }

		</div>
	);
}

function getProductsPerSlide ()
{
	return window.innerWidth > 1400 ? 5
	: window.innerWidth >= 1024 ? 4
	: window.innerWidth >= 768 ? 3
	: 1;
}

function getProductsLimit ()
{
	return window.innerWidth > 1400 ? 5 * 3
	: window.innerWidth >= 1024 ? 4 * 3
	: window.innerWidth >= 768 ? 3 * 4
	: 1 * 8;
}

function getMaxSlidesCount ()
{
	const products_per_slide = getProductsPerSlide();
	const products_limit = getProductsLimit();

	return Number((products_limit / products_per_slide).toFixed(0));
}
